import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ServiceGrid from '../components/ServiceGrid';
import ContactUs from '../components/ContactUs';
import AboutUs from '../components/AboutUs';
import TextSlider from '../components/TextSlider';

function HomePage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="App bg-[#fafafa] min-h-screen">

      {/* SEO + Google Branding */}
      <Helmet>
        <title>VBM Construction | Expert Restoration Services</title>
        <meta
          name="description"
          content="VBM Construction is a professional construction company providing residential and commercial construction services."
        />
        <link rel="canonical" href="https://vbmconstruction.com/" />

        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "ConstructionCompany",
            "name": "VBM Construction",
            "url": "https://vbmconstruction.com",
            "logo": "https://vbmconstruction.com/logo.png"
          }
          `}
        </script>
      </Helmet>

      <Header />
      <Hero />
      <AboutUs />
      <TextSlider />
      <ServiceGrid />
      <ContactUs />
    </div>
  );
}

export default HomePage;
